import {Component} from '@angular/core';
import {CreateGlobalDriveCommand} from '../../commands/create-directory.command';
import {AddDriveDialogComponent} from '../add-drive-dialog/add-drive-dialog.component';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Router} from '@angular/router';
import {SharedDrivesComponent} from './shared-drives.component';
import {MatDialog} from '@angular/material/dialog';
import {CommandService} from '@core/services/command.service';
import {ShareItemService} from '@shared/services/share-item.service';
import {DialogService} from '@shared/services/dialog-service';
import {FileManagerService} from '../../services/file-manager.service';
import {GridValueChangeEvent} from '@shared/models/common.models';

@Component({
    standalone: false,
    selector: 'particle-shared-drives',
  templateUrl: './shared-drives.component.html',
  styleUrls: ['./shared-drives.component.scss']
})
export class OrbitaxDrivesComponent extends SharedDrivesComponent {
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];

  constructor(router: Router, dialog: MatDialog,
              commandService: CommandService,
              shareItemService: ShareItemService,
              dialogService: DialogService,
              fileManagerService: FileManagerService
  ) {
    super(router, dialog, commandService, shareItemService, dialogService, fileManagerService);
    this.sourceKey = 'OrbitaxSharedDrives';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'OrbitaxDrives',
        title: 'Orbitax Drives',
        relativeUrl: 'orbitax-drives'
      }
    ];
    this.canAddDrive = false;
  }

  onGridCellValueChange($event: GridValueChangeEvent) {
    if ($event.item.cells['Type']) {
      switch ($event.item.cells['Type'].value) {
        case 'OrbitaxDrives':
          this.router.navigateByUrl('orbitax-drives');
          break;
        case 'SharedDrive':
          this.router.navigateByUrl(`orbitax-drive/${$event.item.id}`);
          break;
        case 'PersonalDrive':
          this.router.navigateByUrl(`orbitax-drive/${$event.item.id}`);
          break;
      }
    } else {
      if (!$event.item.cells['DriveId'] || !$event.item.cells['DriveId'].value) {
        console.error('Drive ID not found');
      } else {
        this.router.navigateByUrl(`orbitax-drive/${$event.item.cells['DriveId'].value}/${$event.item.id}`);
      }
    }
  }

  addDrive() {
    const dialogRef = this.dialog.open(AddDriveDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      disableClose: true
    });
    dialogRef.afterClosed().pipe().subscribe((result: string) => {
      if (result) {
        this.commandService.executeCommand(new CreateGlobalDriveCommand(result)).pipe().subscribe(data => {
          this.router.navigateByUrl(`orbitax-drive/${data.Payload.Id}`);
        });
      }
    });
  }
}
